<template>
   <div v-if="dialogVisible">
    <el-dialog
    :visible.sync="dialogVisible"
    :title="titleList.get(typeDialog)"
    :width="'824px'"
    :before-close="cancelHandle"
    >
    <info-item label="维保类型" :value="data.type === 2? '保养' : '维修'"></info-item>
    <info-item label="维保总费用" :value="data.totalAmount" v-if="typeDialog !== 3"></info-item>
    <info-confirm :data="data" v-if="typeDialog === 1" @priceChange="handleChange"/>
    <info-pay :data="data" v-if="typeDialog === 2"/>
      <!-- 图片展示 -->
    <div class="photos">
      <div class="photo-item" v-for="(item, index) in imageList" :key="index">
        <div>{{item.label}}:</div>
        <div class="photo-list-item" v-if="Array.isArray(item.value) &&  item.value.length>0">
          <el-image
          v-for="(child,idx) in item.value"
          :key="idx"
          style="width: 100px; height: 100px"
          :src="imgSrc(child)"
          fit="fit"></el-image>
        </div>
      </div>
    </div>

      <div slot="footer">
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" @click="handleOK"
          >确认</el-button
        >
      </div>
    </div>
    </el-dialog>
   </div>
</template>

<script>
import InfoItem from '@/components/infoItem'
import { maintenanceDetail } from '@/api/domain/carsService'
import InfoConfirm from './infoConfirm.vue'
import InfoPay from './infoPay.vue'
import { maintenanceConfirmReceivableApi, maintenancePayApi } from './services'
import config from './config'

export default {
  name: 'InfoDialog',
  components: {
    InfoItem,
    InfoConfirm,
    InfoPay,
  },
  props: {},
  data() {
    const { titleList } = config.call(this)
    return {
      dialogVisible: false,
      data: {},
      imageList: [],
      exceedAmount: 0,
      floatAmount: 0,
      depreciationAmount: 0,
      titleList,
      typeDialog: 0,
    }
  },
  methods: {
    imgSrc(child) {
      const imgList = this.getURL({ data: child, needName: true })
      if (Array.isArray(imgList) && imgList.length > 0) {
        return imgList[0].url
      }
      return ''
    },
    handleChange(val, type) {
      if (type === 'exceedAmount') {
        this.exceedAmount = val
      } else if (type === 'floatAmount') {
        this.floatAmount = val
      } else if (type === 'depreciationAmount') {
        this.depreciationAmount = val
      }
    },
    handleOK() {
      const params = {
        id: this.data.id,
      }
      if (this.typeDialog === 1) {
        if (this.data.type === 1) {
          params.floatAmount = this.floatAmount || 0
          params.depreciationAmount = this.depreciationAmount || 0
        } else if (this.data.type === 2) {
          params.exceedAmount = this.exceedAmount
        }
        this.maintenanceConfirmReceivable(params)
      } else if (this.typeDialog === 2) {
        this.maintenancePay(params)
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    open(rowData) {
      this.dialogVisible = true
      this.typeDialog = rowData.typeDialog
      this.getList({ id: rowData.id })
    },
    cancelHandle() {
      this.data = {}
      this.imageList = []
      this.typeDialog = 0
      this.dialogVisible = false
      this.$emit('update')
    },
    async getList(res) {
      const { code, data } = await maintenanceDetail(res)
      if (code !== 1) return
      // if (!data.type) {
      //   this.$message.error('暂无信息')
      //   this.cancelHandle()
      //   return
      // }

      const _data = {}
      _data.type = data.type || 1
      _data.totalAmount = data.totalAmount || '--'
      _data.lastMaintenanceKm = data.lastMaintenanceKm || '--'
      _data.incomeKm = data.incomeKm || '--'
      _data.overMaintenanceKm = data.overMaintenanceKm || '--'
      _data.exceedAmount = data.exceedAmount || '--' // 超保费
      _data.floatAmount = data.floatAmount || '--' // 保险上浮费
      _data.depreciationAmount = data.depreciationAmount || '--' // 加速折旧费
      _data.id = data.id

      this.data = _data

      // 维保图片处理
      if (data.photo) {
        const _imageData = JSON.parse(data.photo)
        let tempImageList
        if (Number(data.type) === 2) {
          tempImageList = [
            { label: '进厂图片', value: this.getImageList(_imageData.enterFactoryPictures) },
          ]
        } else if (Number(data.type) === 1) {
          tempImageList = [
            {
              label: '进厂图片',
              value: this.getImageList(_imageData.enterFactoryPictures),
            },
            {
              label: '维修更换部件照片',
              value: this.getImageList(_imageData.maintenancePictures),
            },
            {
              label: '事故现场照片',
              value: this.getImageList(_imageData.accidentScenePictures),
            },
            {
              label: '责任认定书',
              value: this.getImageList(_imageData.responsibilityPictures),
            },
            {
              label: '定损单',
              value: this.getImageList(_imageData.lossOrderPictures),
            },
          ]
        } else {
          tempImageList = [
            { label: '进厂图片', value: this.getImageList(_imageData.enterFactoryPictures) },
            { label: '维修更换部件照片', value: this.getImageList(_imageData.maintenancePictures) },
            { label: '事故现场照片', value: this.getImageList(_imageData.accidentScenePictures) },
            { label: '责任认定书', value: this.getImageList(_imageData.responsibilityPictures) },
            { label: '定损单', value: this.getImageList(_imageData.lossOrderPictures) }]
        }
        this.imageList = tempImageList
      }
    },
    // 获取图片集合
    getImageList(image) {
      const arr = typeof image === 'string' ? JSON.parse(image) : image
      if (Array.isArray(arr) && arr.length > 0) {
        return arr.map((item) => item)
      } else {
        return []
      }
    },
    async maintenanceConfirmReceivable(data) {
      const [err, _data] = await this.$to(maintenanceConfirmReceivableApi(data))
      if (!err) {
        const { code } = _data
        if (code === 1) {
          this.$message.success('确认成功')
          this.cancelHandle()
        }
      }
    },
    async maintenancePay(data) {
      const [err, _data] = await this.$to(maintenancePayApi(data))
      if (!err) {
        const { code } = _data
        if (code === 1) {
          this.$message.success('确认成功')
          this.cancelHandle()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.photos{
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-content:flex-start;
  flex-wrap: wrap;
  .photo-item{
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 10px;
    margin-right: 15px;
    &>div:nth-child(1){
      margin-bottom: 10px;

    }
  }
  .photo-list-item{
    display: flex;
    &>*{
      margin-right: 10px;
    }
  }
}
</style>
